export default __webpack_public_path__ + "static/media/Body Temp.f0688788.svg";